import React from 'react';

//Hooks
import {useState, useEffect, useCallback, useRef} from 'react';
import {useSelector} from "react-redux";

//Styles
import Styles from './ScreenFooter.module.scss';

const ScreenFooter = ({visible, children}) => {
    const [isVisible, setVisible] = useState(visible);
    const [isEditing, setEditing] = useState(false);
    const [visibleClass, setVisibleClass] = useState(visible);
    const [animationTimeout, setAnimationTimeout] = useState(null);

    const style = useSelector(state => state.widget.style);

    const initialHeight = useRef(window.innerHeight);

    useEffect(() => () => clearTimeout((animationTimeout)));

    useEffect(() => {
        setAnimationTimeout(animationTimeout => {
            clearTimeout(animationTimeout);
            return null;
        });

        if(visible) {
            setVisible(true);
            setAnimationTimeout(setTimeout(/* istanbul ignore next */ () => setVisibleClass(true)));
        } else {
            setVisibleClass(false);
            setAnimationTimeout(setTimeout(/* istanbul ignore next */() => setVisible(false), 500));
        }
    }, [visible]);

    const handleEditing = useCallback(/* istanbul ignore next */ () => {
        if(window.innerWidth > 991) {
            return;
        }

        setEditing(initialHeight.current > window.innerHeight);
    }, []);

    useEffect(() => {
        handleEditing();
    }, [handleEditing]);

    useEffect(() => {
        window.addEventListener('resize', handleEditing);

        return /* istanbul ignore next */ () => {
            window.removeEventListener('resize', handleEditing);
        };
    }, [handleEditing]);

    /* istanbul ignore next */
    if(!isVisible || isEditing) {
        return null;
    }

    return (
        <footer className={[
            Styles.container,
            visibleClass ? Styles.visible : '',
            style === 'inline' ? Styles.inline : '',
            (style === 'dev' || style === 'website') ? Styles.website : ''
        ].join(' ')}>
            <div className={Styles.content}>
                {children}
            </div>
        </footer>
    );
};

export default ScreenFooter